import { DraftReturnSchema } from "@redotech/redo-model/draft-return/draft-return";
import * as z from "zod";

export enum ChangeResetPointErrorCode {
  ReturnNotFound = "ReturnNotFound",
  InvalidResetPoint = "InvalidResetPoint",
}

export const changeResetPoint = {
  name: "changeResetPoint" as const,
  input: z.object({
    draftReturnId: z.string(),
    reset: z.object({
      returnableItemId: z.string(),
      step: z.number(),
      flow: z.any(),
    }),
  }),
  output: z.object({ draftReturn: DraftReturnSchema }),
};
